/**
 * Billing and Payment Terms – Payment terms for NAC Stock Management System
 */
import React from 'react';
import { Typography, Card } from 'antd';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PublicPageLayout from '../components/PublicPageLayout';
import './TermsOfUse.css';

const { Title, Paragraph } = Typography;

const BillingPayment: React.FC = () => {
  return (
    <PublicPageLayout>
      <Helmet>
        <title>Billing & Payment – NAC Software and Tech Solutions</title>
        <meta name="description" content="Billing and payment terms for the Bhutan NAC Stock Management System." />
      </Helmet>
      <div className="terms-content">
        <Link to="/" className="terms-back">← Back to Home</Link>
        <Title level={2}>Billing & Payment</Title>
        <Paragraph type="secondary">Last updated: {new Date().toLocaleDateString()}</Paragraph>

        <Card className="terms-card">
            <Title level={4}>1. Subscription and Fees</Title>
            <Paragraph>
              Fees for the NAC Stock Management System are determined at the time of company registration. Pricing may vary based on company size, number of users, and features. Contact us for current pricing.
            </Paragraph>

            <Title level={4}>2. Payment Terms</Title>
            <Paragraph>
              Payment is due as per the agreement between you and NAC Software and Tech Solutions. We accept payment methods as communicated during registration. Invoices will be sent to the email address on file.
            </Paragraph>

            <Title level={4}>3. Billing Cycle</Title>
            <Paragraph>
              Billing may be monthly, quarterly, or annually depending on your plan. Renewal dates and amounts will be communicated in advance. Auto-renewal may apply unless you cancel before the renewal date.
            </Paragraph>

            <Title level={4}>4. Late Payment</Title>
            <Paragraph>
              Late payments may result in suspension of service until the balance is cleared. We will attempt to notify you before suspending access. Interest or late fees may apply as per your agreement.
            </Paragraph>

            <Title level={4}>5. Refunds and Cancellations</Title>
            <Paragraph>
              Refund and cancellation policies are as specified in your service agreement. Contact us to discuss cancellation or refund requests.
            </Paragraph>

            <Title level={4}>6. Price Changes</Title>
            <Paragraph>
              We may adjust pricing with reasonable notice. Price changes will not apply to your current billing period unless otherwise agreed. You may cancel if you do not accept the new pricing.
            </Paragraph>

            <Title level={4}>7. Contact</Title>
            <Paragraph>
              For billing inquiries, contact us at{' '}
              <a href="mailto:nacsoftwareandtechsolutions26@gmail.com">nacsoftwareandtechsolutions26@gmail.com</a>.
            </Paragraph>
          </Card>
      </div>
    </PublicPageLayout>
  );
};

export default BillingPayment;
